import { getRouteApi, redirect } from "@tanstack/react-router";

import { GenerationsStepShell } from "@/features/Generations/components/GenerationsStepShell";
import {
  DEFAULT_STEP_ID_BY_GROUP,
  generationsStepRoutePath,
  isGenerationsStepIdInGroup,
  type GenerationsStepGroupId,
} from "@/features/Generations/steps";

const ROUTE_ID_BY_GROUP = {
  pilot: "/_auth/generations/$siteId/new/pilot/$stepId",
  collection: "/_auth/generations/$siteId/new/collection/$stepId",
} as const;

// Both `new/pilot/$stepId` and `new/collection/$stepId` guard the step id
// against their group and render the shell; the route files pass this in.
export function generationsStepRouteOptions(group: GenerationsStepGroupId) {
  const defaultStepId = DEFAULT_STEP_ID_BY_GROUP[group];
  const routeApi = getRouteApi(ROUTE_ID_BY_GROUP[group]);

  function StepRouteComponent() {
    const { siteId, stepId } = routeApi.useParams();
    if (!isGenerationsStepIdInGroup(stepId, group)) return null;
    return <GenerationsStepShell siteId={siteId} stepId={stepId} />;
  }

  return {
    beforeLoad: ({
      params,
    }: {
      params: { siteId: string; stepId: string };
    }) => {
      if (!isGenerationsStepIdInGroup(params.stepId, group)) {
        throw redirect({
          to: generationsStepRoutePath(defaultStepId),
          params: { siteId: params.siteId, stepId: defaultStepId },
        });
      }
    },
    component: StepRouteComponent,
  };
}
